import { render, staticRenderFns } from "./sidebar-item.vue?vue&type=template&id=7a1280c0&scoped=true&"
import script from "./sidebar-item.vue?vue&type=script&lang=js&"
export * from "./sidebar-item.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-item.vue?vue&type=style&index=0&id=7a1280c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1280c0",
  null
  
)

export default component.exports